import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag sälja vin för avhämtning tillsammans med mat?";
const SHORT_ANSWER = "Ja, från 1 juni 2026 är takeaway-försäljning av alkohol tillsammans med mat tillåtet enligt prop. 2025/26:21.";

export const Route = createFileRoute("/fraga/far-jag-salja-takeaway-vin-med-mat")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag sälja vin för avhämtning tillsammans me…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Försäljningen ska ske från restaurangen, kunden ska beställa både mat och alkohol, och alkoholen ska tas hem direkt. Mängd och fördelning regleras särskilt; kontrollera kommunens tillämpning."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/nya-regler-serveringstillstand-2026", label: "Nya regler 2026 – takeaway och hemleverans" }}
      related={[{"to": "/fraga/vad-galler-for-happy-hour", "label": "Får jag erbjuda happy hour?"}, {"to": "/fraga/far-jag-marknadsfora-alkohol-i-sociala-medier", "label": "Får jag marknadsföra alkohol på sociala medier?"}, {"to": "/fraga/far-jag-tillata-egen-medhavd-alkohol", "label": "Får gäster ta med egen alkohol till restaurangen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag sälja vin för avhämtning tillsammans med mat?" },
      { name: "description", content: "Ja, från 1 juni 2026 är takeaway-försäljning av alkohol tillsammans med mat tillåtet enligt prop. 2025/26:21." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-salja-takeaway-vin-med-mat" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-salja-takeaway-vin-med-mat" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-salja-takeaway-vin-med-mat",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag sälja vin för avhämtning tillsammans me…", url: "https://alkoholprovet.se/fraga/far-jag-salja-takeaway-vin-med-mat" },
      ]),
    ],
  }),
});
